import React from 'react';
import KindList from './KindList';
import withSearchState from 'app/withSearchState';

const Kind = ({ getUriState, pushUriStateWithoutPage }) => {
  const { kind } = getUriState();
  const handleChange = e => {
    pushUriStateWithoutPage({ kind: e.target.value });
  };
  return <KindList value={kind} onChange={handleChange} />;
};

export default withSearchState(Kind);
